import React from 'react'
import { BootContext } from './BootProvider'

export const useBoot = () => {
  const { bootComplete } = React.useContext(BootContext)
  return { bootComplete }
}
